var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSketching(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#662E57"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#590F38"
    },
    d: "M512,256c0-1.637-0.031-3.266-0.062-4.895L411.167,150.333l-43.825,82.042L223.039,88.544 l-21.777,89.418l-51.074-52.629l-43.579,254.346l45.167,45.167l-7.276,2.197l83.418,83.418c9.224,1.007,18.59,1.54,28.082,1.54 C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M97.833,358.583v-208.25h313.333v238H127.583C111.153,388.333,97.833,375.014,97.833,358.583z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M97.833,255.905v102.678c0,16.431,13.32,29.75,29.75,29.75h283.583V255.905H97.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M157.833,358.333c0-16.569-13.431-30-30-30s-30,13.431-30,30v-213c0-16.569,13.431-30,30-30 s30,13.431,30,30V358.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C0C0"
    },
    d: "M97.833,255.905v102.428c0-16.568,13.431-30,30-30s30,13.432,30,30V255.905H97.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB344"
    },
    d: "M144.5,427.042h235v-235L144.5,427.042z M337.563,385.104h-87.124l87.124-87.124V385.104z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9451"
    },
    points: "379.5,427.042 337.563,385.104 250.438,385.104 293.688,341.854 261.688,309.854  144.5,427.042 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6838"
    },
    d: "M228.333,289.667L205,327.089l-23.333-37.422V101.5c0-10.217,8.283-18.5,18.5-18.5h9.667 c10.217,0,18.5,8.283,18.5,18.5L228.333,289.667L228.333,289.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AE4E32"
    },
    d: "M209.833,83h-5.071v243.707l0.238,0.382l23.333-37.422V101.5C228.333,91.283,220.051,83,209.833,83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BAFF"
    },
    d: "M228.333,101.5c0-10.217-8.283-18.5-18.5-18.5h-9.667c-10.217,0-18.5,8.283-18.5,18.5v23.833h46.667 L228.333,101.5L228.333,101.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008CC3"
    },
    d: "M228.333,101.5c0-10.217-8.283-18.5-18.5-18.5h-5.071v42.333h23.571V101.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.67,
    y: 120.67,
    style: {
      fill: "#FF9451"
    },
    width: 46.667,
    height: 15.333
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.76,
    y: 120.67,
    style: {
      fill: "#F7674F"
    },
    width: 23.571,
    height: 15.333
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD863"
    },
    points: "228.333,289.667 181.667,289.667 195.8,312.333 214.2,312.333 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFCF35"
    },
    points: "228.333,289.667 204.762,289.667 204.762,312.333 214.2,312.333 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#333333"
    },
    points: "214.2,312.333 195.8,312.333 205,327.089 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1A1A1A"
    },
    points: "214.2,312.333 204.762,312.333 205,327.089 205,327.089 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSketching);
export default __webpack_public_path__ + "static/media/sketching.2100de04343b84417297587d4a8737b2.svg";
export { ForwardRef as ReactComponent };